import React, { useEffect, useState, useContext } from "react";
import { Select } from "antd";
import FetchEmployeesService from "./FetchEmployeesService";


const { Option } = Select;

const EmployeeRootList = ({ onSelect, selectedCustomer, setSelectedCustomer, selectedLocation, title,token }) => {
  const [customerList, setCustomerList] = useState([]);


  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const data = await FetchEmployeesService(token, selectedLocation);
        setCustomerList(data);
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };

    fetchCustomers();
  }, [selectedLocation]);

  const handleChange = (value) => {
    const selected = customerList.find(c => c.id === value);
    setSelectedCustomer(selected);
    if (onSelect) onSelect(selected);
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 8 }}>
        {title || 'Select Employee'}
      </label>

      <Select
        
        style={{ width: 300 }}
        placeholder="Choose an employee"
        optionFilterProp="children"
        value={selectedCustomer?.id}
        onChange={handleChange}
       
      >
        {customerList && customerList.map((customer) => (
          <Option key={customer.id} value={customer.id}>
            {customer.firstName} {customer.lastName}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default EmployeeRootList;
